// Copyright (c) 2021 Deere & Company

import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import {FormattedMessage} from 'react-intl';
import KeyValueDropDown from '../../shared/components/claim-fields/key-value-dropdown';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import LaborRateRequestList from './labor-rate-request-list';
import RefinableListWidget from '../../../shared/components/refinable-list-widget';
import SearchFilters from '../../../shared/state/search-filters';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import sortOptions from '../constants/sort-options';

const getRequestStatus = status => {

    const map = {
        '01': 'NEW',
        '02': 'ACCEPTED',
        '03': 'REJECTED',
        '04': 'RETURNED'
    };

    return map[status];

};

function handleFilterByChange(filterBy) {

    this.actions.updateListFilterBy(this.massLaborRateRequestStatusDetails, filterBy);

}

function handleSortByChange(sortBy) {

    this.actions.updateListSortBy(this.massLaborRateRequestStatusDetails, sortBy, this.searchFilters.sortDirection);

}

function handleSortDirectionChange(sortDirection) {

    this.actions.updateListSortDirection(this.massLaborRateRequestStatusDetails, this.searchFilters.sortBy, sortDirection);

}

class MassLaborRateRequestStatus extends Component {

    state = {
        selectedValue: this.props.queryParams.status
    };

    componentWillMount() {

        this.props.actions.readAllRequestAsPerStatus(getRequestStatus(this.props.queryParams.status), this.props.searchFilters);

    }

    handleRequestStatusChange = event => {

        this.props.actions.readAllRequestAsPerStatus(getRequestStatus(event.target.value), this.props.searchFilters);

        this.setState({
            selectedValue: event.target.value
        });

    };

    render() {

        return (
            <section className='labor-rate-request-details'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <h2>
                    <FormattedMessage id='LABOR_RATE_REQUESTS_STATUS'/>
                </h2>
                <div className='request-status-dropdown-group'>
                    <KeyValueDropDown
                        className='claim-statuses'
                        list={this.props.requestStatus}
                        onChange={this.handleRequestStatusChange}
                        shouldTranslate={true}
                        showBlankOption={false}
                        value={this.state.selectedValue}
                    />
                </div>
                <section className='request-search-results-container'>
                    <RefinableListWidget
                        onFilterByChange={this.props::handleFilterByChange}
                        onSortByChange={this.props::handleSortByChange}
                        onSortDirectionChange={this.props::handleSortDirectionChange}
                        searchFilters={this.props.searchFilters}
                        sortOptions={sortOptions}
                    />
                    <LaborRateRequestList
                        actions={this.props.actions}
                        busyCounter={this.props.busyCounter}
                        isEditable={false}
                        laborRateRequests={this.props.requestFiltered}
                    />
                </section>
            </section>
        );

    }

}

MassLaborRateRequestStatus.displayName = 'MassLaborRateRequestStatus';
MassLaborRateRequestStatus.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    massLaborRateRequestStatusDetails: PropTypes.arrayOf(PropTypes.instanceOf(LaborRate)).isRequired,
    queryParams: PropTypes.object.isRequired,
    requestFiltered: PropTypes.arrayOf(PropTypes.instanceOf(LaborRate)).isRequired,
    requestStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired
};

export default MassLaborRateRequestStatus;



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-request-status-details/components/index.js